import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-page-spinner-component',
  template: `
      <div id='spinner' *ngIf="state==true" class="spinner-loading">
        <div class="spinner-border text-gray" role="status"></div>
        <p class="small text-gray">Loading...</p>
      </div>
  `
})
export class PageSpinnerComponent {
  @Input()
  state = false;
}
